// extracted by mini-css-extract-plugin
export var component = "PostsModuleHeader-module--component--WWnrY";
export var link = "PostsModuleHeader-module--link--DCojO";
export var linkIcon = "PostsModuleHeader-module--linkIcon--+XVQ8";
export var title = "PostsModuleHeader-module--title--sazrW";